module.exports = __webpack_public_path__ + "img/43.f8470584.png";